const DISTRICTS: Record<string, string> = {
  "01": "Raffles Place / Marina / Cecil",
  "02": "Anson / Tanjong Pagar",
  "03": "Queenstown / Tiong Bahru",
  "04": "Telok Blangah / Harbourfront",
  "05": "Pasir Panjang / Clementi",
  "06": "High Street / Beach Road",
  "07": "Middle Road / Golden Mile",
  "08": "Little India",
  "09": "Orchard / Cairnhill / River Valley",
  "10": "Ardmore / Holland / Tanglin",
  "11": "Novena / Thomson / Watten",
  "12": "Toa Payoh / Balestier / Serangoon",
  "13": "Macpherson / Braddell",
  "14": "Geylang / Eunos",
  "15": "Katong / Joo Chiat / Amber",
  "16": "Bedok / Upper East Coast",
  "17": "Loyang / Changi",
  "18": "Tampines / Pasir Ris",
  "19": "Serangoon Gardens / Hougang / Punggol",
  "20": "Bishan / Ang Mo Kio",
  "21": "Bukit Timah / Clementi Park",
  "22": "Jurong",
  "23": "Bukit Panjang / Choa Chu Kang",
  "24": "Lim Chu Kang / Tengah",
  "25": "Kranji / Woodgrove",
  "26": "Upper Thomson / Springleaf",
  "27": "Yishun / Sembawang",
  "28": "Seletar",
};

// Sorted array avoids JS integer-key reordering ("10"–"28" sort before "01"–"09" in plain objects)
export const DISTRICT_OPTIONS: Array<[string, string]> = Object.entries(DISTRICTS).sort(([a], [b]) => a.localeCompare(b));

export function districtLabel(d: string): string {
  return `D${d} ${DISTRICTS[d] ?? ""}`.trim();
}

// districtToken builds the area-vocabulary token for a 2-digit district
// code ("01" → "d01"). This is what the preferences picker writes into the
// comma-separated `areas` string; the backend's districtCodeFromToken
// parses it back to "01" for the data-engine district filter.
export function districtToken(code: string): string {
  return `d${code}`;
}

// parseDistrictToken normalises any single-district area token
// ("d18" / "D18" / "18" / "d1" / "1") to its 2-digit code ("18" / "01").
// Returns "" for anything that isn't a 1..28 district (regions, "cbd",
// "any", garbage) so callers can fall through to the macro-area path.
export function parseDistrictToken(token: string): string {
  const m = /^d?0*(\d{1,2})$/i.exec(token.trim());
  if (!m) return "";
  const n = Number.parseInt(m[1], 10);
  if (n < 1 || n > 28) return "";
  return String(n).padStart(2, "0");
}
